// import React from 'react'

// const MyConnections = () => {
//   return (
//     <div>MyConnections</div>
//   )
// }

// export default MyConnections



import { Avatar, Box, Button, Grid, TextField, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import profile_image from "../../../Assets/Media.jpg"
import { useDispatch, useSelector } from 'react-redux'
import actions from '../../../ReduxStore/actions'
import { toast, ToastContainer } from 'react-toastify'
import { Search } from '@mui/icons-material'
import { useNavigate } from 'react-router-dom'

const MyConnections = () => {
    const [inviteData, setInviteData] = useState([])
    const [searchQuery, setSearchQuery] = useState("");


    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value.toLowerCase());
    };

    const invites = [
        {
            name: "Kiruthik Rajan S", profile_image: profile_image, course: "Fashion Technology", campus: "Nation institute of fashion techonolgy,Chennai", batch: "FT2022"
        },
        {
            name: "Kiruthik Rajan S", profile_image: profile_image, course: "Fashion Technology", campus: "Nation institute of fashion techonolgy,Chennai", batch: "FT2022"
        },
        {
            name: "Kiruthik Rajan S", profile_image: profile_image, course: "Fashion Technology", campus: "Nation institute of fashion techonolgy,Chennai", batch: "FT2022"
        },
        {
            name: "Kiruthik Rajan S", profile_image: profile_image, course: "Fashion Technology", campus: "Nation institute of fashion techonolgy,Chennai", batch: "FT2022"
        },

    ]
    const filteredUsers = inviteData?.filter((user) =>
        user.name.toLowerCase().includes(searchQuery) ||
        user.course.toLowerCase().includes(searchQuery) ||
        user.campus.toLowerCase().includes(searchQuery) ||
        user.batch.toLowerCase().includes(searchQuery)



    );

    const dispatch = useDispatch()
    const sessionUserId = sessionStorage.getItem("userId")
    const { sendConnectionRequest } = useSelector(
        (state) => state?.sendConnectionRequest
    );

    //get all post api integration

    // useEffect(() => {
    //     setInviteData(invites)

    // }, [])
    const navigate = useNavigate()
    const capitalize = (str) => str ? str.charAt(0).toUpperCase() + str.slice(1).toLowerCase() : '';
    

    
    

    useEffect(() => {


        const fetchData = async () => {
            const data1 = {
                data: {},
                method: "get",
                apiName: `getUserConnections/${sessionUserId}`,
            };
            const response = await dispatch(actions.GETUSERCONNECTIONS(data1));

            console.log(response, "responseresponse")

            if (response?.payload?.message === "Connections fetched.") {
                console.log("hiiiiiiiiiiiiiiii")

                const responseData = response?.payload?.data?.map((data) => ({
                    user_id: data?.user_id,
                    name: `${capitalize(data?.first_name)} ${capitalize(data?.last_name)}`,
                    course: capitalize(data?.course),
                    campus: capitalize(data?.campus),
                    profileImage: data?.profileImage,
                    batch: data?.batch



                }))
                setInviteData(responseData)

            }
        }
        fetchData()


    }, [])


    const handleConnectButton = async (user_id) => {
        console.log(user_id, "userrrrrrrrr")
        navigate(`/user/viewprofiledetails/${user_id}`)

        // const data1 = {
        //     data: {
        //         sender_id: Number(sessionUserId),
        //         receiver_id: Number(user_id)
        //     },
        //     method: "post",
        //     apiName: `sendConnectionRequest`,
        // };
        // const response = await dispatch(actions.SENDCONNECTIONREQUEST(data1));
        // console.log(response, "responsedataaaaaaa")
        // if (response?.payload?.message === "Connection request sent.") {
        //     toast?.success('Connection request sent successfully!')
        // } else {
        //     toast.error(response?.payload?.message)
        // }


    }


    return (
        <Box sx={{ minHeight: "80vh" }}>

            <Box display="flex" flexDirection={{ xs: "column", md: "row" }} alignItems="center" justifyContent="space-between" gap={2}>
                {/* Filters */}


                {/* Status Filters */}
                <Box display="flex" flexDirection={{ xs: "column", md: "row" }} justifyContent="space-between" width="100%" alignItems="center">
                    <Typography variant='subtitle2' sx={{ fontSize: '17px', color: "black",mb:{xs:1,md:0} }}>
                        My Connections({inviteData?.length})
                    </Typography>
                    <TextField
                        size="small"
                        placeholder="Search"
                        variant="outlined"
                        InputProps={{ endAdornment: <Search /> }}
                        // sx={{borderRadius:'20px'}}
                        sx={{
                            minWidth: 200,
                            "& .MuiOutlinedInput-root": {
                                borderRadius: "20px",
                                "& fieldset": {
                                    borderRadius: "20px", // Applies to the actual border
                                },
                                "&:hover fieldset": {
                                    borderColor: "#F9BF10", // Change border color on hover
                                },
                                "&.Mui-focused fieldset": {
                                    borderColor: "#F9BF10", // Change border color on focus
                                },
                            },
                        }}
                        value={searchQuery}
                        onChange={(event) => handleSearchChange(event)}
                    />
                </Box>

            </Box>
            <Grid container spacing={2}>

                {filteredUsers?.length > 0 ? (
                    <>
                        {filteredUsers?.map((invite, index) => (
                            <Grid size={{ xs: 12, md: 6 }}>
                                <Grid container
                                    sx={{
                                        // boxShadow: 4,
                                        background: "white",
                                        p: 2,
                                        border: "1px solid white",
                                        mt: 2
                                    }}>
                                    <Grid size={{ xs: 12, md: 12, sm: 12 }}>

                                        <Box display="flex" alignItems="center" gap={1} mb={1}>
                                            <Avatar src={invite.profile_image}
                                                sx={{
                                                    border: "1px solid gray",
                                                    height: 80,
                                                    width: 80,
                                                    "& .MuiAvatar-img": {
                                                        objectFit: "contain"
                                                    }
                                                }} />
                                            <Box>
                                                <Typography variant='customText' sx={{ color: 'black' }}>{invite?.name}</Typography>
                                                <Typography variant="subtitle2" sx={{ color: 'gray', mt: 0.2 }}>{invite?.course}</Typography>
                                                <Typography variant="subtitle2" sx={{ color: 'gray', mt: 0.2 }}>{invite?.campus}</Typography>

                                                <Typography variant="body1">{invite?.batch}</Typography>

                                            </Box>
                                        </Box>

                                    </Grid>
                                    <Grid size={{ xs: 12, md: 12, sm: 12 }}
                                        sx={{ display: "flex", justifyContent: "end", alignItems: "center" }}
                                    >
                                        <Box>

                                            <Button

                                                onClick={() => {
                                                    handleConnectButton(invite?.user_id)
                                                }
                                                }
                                                sx={{
                                                    border: "1px solid var(--main-color)",
                                                    background: "white",
                                                    color: "var(--main-color)",
                                                    textTransform: "none",
                                                    fontSize: "14px",
                                                    padding: "2px 20px"
                                                }}
                                            >
                                                View Details
                                            </Button>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Grid>
                        ))}
                    </>
                )
                    : (
                        <Box sx={{ display: 'flex', justifyContent: "center", alignItems: "center", height: "50vh", width: "100%" }}>
                            <Typography variant='subtitle2' sx={{ fontSize: '17px', color: "gray" }}>
                                No Suggestions found

                                {/* ({inviteData?.length}) */}
                            </Typography>
                        </Box>

                    )}

            </Grid>
            {/* </Grid> */}
            <ToastContainer
                position="top-right"
                autoClose={1500}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="dark"
            />
        </Box >
    )
}

export default MyConnections
